import * as productCardDatalayer from '@datalayer/components/product-card-datalayer';
import { buildProduct } from '@datalayer/components/product-datalayer';

function bindClickListener($el, product) {
    const $link = $el.find('[data-control="productLink"]');
    $link.on('click', () => productCardDatalayer.sendClick(
        'USD', // todo: wire up currency code
        product
    ));
}

const getProductData = ($el) => buildProduct({
    id: $el.data('product-id'),
    variantId: $el.data('variant-id') || undefined,
    name: $el.data('name') || undefined,
    brand: $el.data('brand') || undefined,
    category: $el.data('category') || undefined,
    list: $el.data('list') || undefined,
    price: $el.data('price'),
    discount: $el.data('discount'),
    rxRequired: $el.data('rx-required'),
    strength: $el.data('strength') || undefined,
    packaging: $el.data('packaging') || undefined
});

$(() => {
    const rootEls = document.querySelectorAll('.js-product-card');
    let products = [];

    rootEls.forEach((el) => {
        const $el = $(el);
        const product = getProductData($el);

        products.push(product);
        bindClickListener($el, product);
    });

    productCardDatalayer.sendImpression(
        'USD', // todo: wire up currency code
        products
    );
});
